import { render, staticRenderFns } from "./RemoveCard.vue?vue&type=template&id=ff09ec3a&scoped=true"
import script from "./RemoveCard.vue?vue&type=script&lang=js"
export * from "./RemoveCard.vue?vue&type=script&lang=js"
import style0 from "./RemoveCard.vue?vue&type=style&index=0&id=ff09ec3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff09ec3a",
  null
  
)

export default component.exports